import React from "react";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";

export default function Work({ title, desc, tags, link, code, img }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      whileHover={{ y: -10 }}
    >
      <Tilt
        options={{
          max: 25,
          scale: 1.02,
          speed: 450,
        }}
        className="group relative"
      >
        <div className="glass-dark rounded-3xl max-w-[380px] h-full p-1 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/20">
          <div className="bg-gradient-to-br from-gray-900 to-black w-full h-full rounded-3xl p-6 flex flex-col justify-between relative overflow-hidden">
            {/* Background Gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-purple-500/5 to-pink-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            <div className="relative z-10">
              <div className="relative w-full rounded-2xl overflow-hidden mb-6">
                <motion.img
                  src={img}
                  alt={title}
                  className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                  whileHover={{ scale: 1.05 }}
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Action Buttons */}
                <div className="absolute top-4 right-4 flex gap-3 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                  <motion.button
                    onClick={() => window.open(link, "_blank")}
                    className="glass w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <img
                      src={require("../../assets/images/gotosite.webp")}
                      alt="Visit site"
                      className="w-5 h-5 object-contain"
                    />
                  </motion.button>
                  <motion.button
                    onClick={() => window.open(code, "_blank")}
                    className="glass w-10 h-10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <img
                      src={require("../../assets/images/github.webp")}
                      alt="View code"
                      className="w-5 h-5 object-contain"
                    />
                  </motion.button>
                </div>
              </div>

              <div className="space-y-4">
                <motion.h3 
                  className="text-white font-bold text-xl leading-tight"
                  whileHover={{ color: "#3b82f6" }}
                  transition={{ duration: 0.2 }}
                >
                  {title}
                </motion.h3>
                <p className="text-gray-300 text-sm leading-relaxed line-clamp-4">
                  {desc}
                </p>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap gap-2 relative z-10">
              {tags.map((tag, index) => (
                <motion.span
                  key={tag.name}
                  className={`text-xs font-medium px-3 py-1 rounded-full glass border border-white/10 text-${tag.color} hover:bg-white/10 transition-colors cursor-default`}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  whileHover={{ scale: 1.05 }}
                >
                  {tag.name}
                </motion.span>
              ))}
            </div>

            {/* Hover Effect Lines */}
            <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
          </div>
        </div>
      </Tilt>
    </motion.div>
  );
}